import React from 'react';

/**
 * Shared wrapper for CRM communication panels – full card or sidebar (ServiceTaskDetail-style).
 * @param {{ embedded?: boolean, title?: string, help?: string, t: (k: string) => string, children: React.ReactNode, className?: string }} props
 */
export function CrmPanelShell({ embedded = false, title, help, t, children, className = '' }) {
  if (embedded) {
    return (
      <div className={`mb-3 ${className}`.trim()}>
        {title ? <label className="font-bold mb-1 block text-gray-900">{title}</label> : null}
        {help ? <p className="text-xs text-gray-500">{help}</p> : null}
        {children}
      </div>
    );
  }

  return (
    <section className={`rounded-lg border border-gray-200 bg-white p-4 shadow-sm ${className}`.trim()}>
      {title ? <h3 className="text-base font-semibold text-gray-900">{title}</h3> : null}
      {help ? <p className="mt-1 text-xs text-gray-500">{help}</p> : null}
      {children}
    </section>
  );
}
